import React from 'react';
export const Footer: React.FC = () => {
  return <footer className="bg-deep-juniper text-sandstone py-16" data-id="element-79">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-80">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8" data-id="element-81">
          <div className="space-y-4" data-id="element-82">
            <div className="text-2xl font-literata font-medium" data-id="element-83">
              Re:<span className="text-rejoy-coral" data-id="element-84">Joy</span>
            </div>
            <p className="text-sandstone/80" data-id="element-85">
              Private by design. Human by purpose.
            </p>
          </div>
          <div data-id="element-86">
            <h3 className="text-lg font-medium mb-4" data-id="element-87">Platform</h3>
            <ul className="space-y-2" data-id="element-88">
              <li data-id="element-89">
                <a href="#" className="hover:text-apricot transition-colors duration-300" data-id="element-90">
                  Home
                </a>
              </li>
              <li data-id="element-91">
                <a href="#how-it-works" className="hover:text-apricot transition-colors duration-300" data-id="element-92">
                  How It Works
                </a>
              </li>
              <li data-id="element-93">
                <a href="#therapists" className="hover:text-apricot transition-colors duration-300" data-id="element-94">
                  Therapists
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-95">
            <h3 className="text-lg font-medium mb-4" data-id="element-96">Resources</h3>
            <ul className="space-y-2" data-id="element-97">
              <li data-id="element-98">
                <a href="#" className="hover:text-apricot transition-colors duration-300 flex items-center gap-2" data-id="element-99">
                  Blog
                  <span className="text-xs bg-sandstone/20 text-sandstone px-2 py-0.5 rounded" data-id="element-100">
                    Coming Soon
                  </span>
                </a>
              </li>
              <li data-id="element-101">
                <a href="#" className="hover:text-apricot transition-colors duration-300 flex items-center gap-2" data-id="element-102">
                  FAQs
                  <span className="text-xs bg-sandstone/20 text-sandstone px-2 py-0.5 rounded" data-id="element-103">
                    Coming Soon
                  </span>
                </a>
              </li>
              <li data-id="element-104">
                <a href="#" className="hover:text-apricot transition-colors duration-300 flex items-center gap-2" data-id="element-105">
                  Support
                  <span className="text-xs bg-sandstone/20 text-sandstone px-2 py-0.5 rounded" data-id="element-106">
                    Coming Soon
                  </span>
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-107">
            <h3 className="text-lg font-medium mb-4" data-id="element-108">Legal</h3>
            <ul className="space-y-2" data-id="element-109">
              <li data-id="element-110">
                <a href="#" className="hover:text-apricot transition-colors duration-300 flex items-center gap-2" data-id="element-111">
                  Privacy Policy
                  <span className="text-xs bg-sandstone/20 text-sandstone px-2 py-0.5 rounded" data-id="element-112">
                    Coming Soon
                  </span>
                </a>
              </li>
              <li data-id="element-113">
                <a href="#" className="hover:text-apricot transition-colors duration-300 flex items-center gap-2" data-id="element-114">
                  Terms of Service
                  <span className="text-xs bg-sandstone/20 text-sandstone px-2 py-0.5 rounded" data-id="element-115">
                    Coming Soon
                  </span>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-sandstone/20 mt-12 pt-8 text-center text-sandstone/60" data-id="element-116">
          © 2025 Re:Joy Health. All rights reserved.
        </div>
      </div>
    </footer>;
};